export default "__VITE_PUBLIC_ASSET__117aba33__"